import { Component, input, output } from '@angular/core';
import { PROMPT_TAGLINE } from '../../data/landing-content';

@Component({
  selector: 'app-prompt-box',
  standalone: true,
  template: `
    <div class="prompt-box" (click)="promptTextarea.focus()">
      <div class="prompt-input-row">
        <textarea
          #promptTextarea
          class="prompt-textarea"
          placeholder="What do you want to get better at?"
          rows="2"
          [value]="value()"
          (input)="onInput($event)"
          (keydown.enter)="onEnter($event)"
        ></textarea>
        <button
          class="prompt-send"
          title="Send"
          aria-label="Send"
          (click)="onSend($event)"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="19" x2="12" y2="5" />
            <polyline points="5 12 12 5 19 12" />
          </svg>
        </button>
      </div>
      <p class="prompt-tagline">{{ tagline() }}</p>
    </div>
  `,
  styleUrl: './prompt-box.component.scss',
})
export class PromptBoxComponent {
  readonly tagline = input(PROMPT_TAGLINE);
  readonly value = input('');

  readonly valueChange = output<string>();
  readonly submit = output<void>();

  onInput(event: Event): void {
    this.valueChange.emit((event.target as HTMLTextAreaElement).value);
  }

  onEnter(event: Event): void {
    event.preventDefault();
    this.submit.emit();
  }

  onSend(event: MouseEvent): void {
    this.submit.emit();
    event.stopPropagation();
  }
}
